import { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Box, Button, CircularProgress, Container, Typography,
  TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper,
  TextField,
  Pagination
} from "@mui/material";
import ArrowBack from '@mui/icons-material/ArrowBack';
import moment from 'moment';

import { getContracts } from "../../services/backend/ContractService";
import { PERMISSIONS } from "../../constants";
import ContractItem from "./ContractItem";

const PAGESIZE = 10;

const ClosedContractList = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.value);
  const [contracts, setContracts] = useState();
  const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState(0);

  const { filteredContract, maxPages } = useMemo(() => {
    let tmpContracts = [...(contracts || [])];

    if (searchText) {
      tmpContracts = contracts?.filter((cont) => cont.contractCode.toLowerCase().includes(searchText.toLocaleLowerCase())
        || cont.supervisors?.map(s => `${s.name} ${s.lastName}`.toLowerCase()).join(' ').includes(searchText.toLowerCase())
        || `${cont.contractor?.name} ${cont.contractor?.lastName} ${cont.contractorNuip}`.toLowerCase().includes(searchText.toLowerCase())
      );
    }
    const maxPages = Math.ceil((tmpContracts?.length || 0) / PAGESIZE);
    tmpContracts = tmpContracts?.filter((__, idx) => idx >= page * PAGESIZE && idx < (page + 1) * PAGESIZE);

    return { filteredContract: tmpContracts, maxPages };
  }, [contracts, searchText, page]);

  const getContractsAsync = async () => {
    const response = await getContracts(user, 'closed');
    const allContracts = response.map((contract) => ({
      ...contract,
      approvedAt: contract.approvedAt ? moment(contract.approvedAt) : null,
      finishedAt: contract.finishedAt ? moment(contract.finishedAt) : null,
      startedAt: contract.startedAt ? moment(contract.startedAt) : null,
      createdAt: contract.createdAt ? moment(contract.createdAt) : null,
      updatedAt: contract.updatedAt ? moment(contract.updatedAt) : null,
      news: contract.news?.map(n => ({
        ...n,
        startedAt: n.startedAt ? moment(n.startedAt) : null,
        finishedAt: n.finishedAt ? moment(n.finishedAt) : null,
      }))
    }));

    setContracts(allContracts);
  };

  useEffect(() => {
    if (!user.permissions.includes(PERMISSIONS.CONTRACT.LIST)) {
      navigate('/');
      return;
    }
    getContractsAsync();
  }, []); // eslint-disable-line

  return (
    <Container maxWidth="lg" style={{ padding: 3, marginTop: 10 }}>
      <Box sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 5,
      }}>
        <Typography variant="h4">
          <Button
            variant="outlined"
            startIcon={<ArrowBack />}
            style={{ margin: 16 }}
            onClick={() => navigate('/contracts')}
          >
            Volver
          </Button>
          Contratos Cerrados
        </Typography>
      </Box>

      <TextField
        label="Buscar contrato"
        onChange={(evt) => {
          setSearchText(evt.target.value);
        }}
        sx={{ mb: 3 }}
      />

      {contracts ? (
        contracts.length > 0 ? (
          <>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="Actions">
                <TableHead>
                  <TableRow>
                    <TableCell>Código del contracto</TableCell>
                    <TableCell>Supervisor</TableCell>
                    <TableCell>Contratista</TableCell>
                    <TableCell>Objeto del contrato</TableCell>
                    <TableCell>Duración</TableCell>
                    <TableCell>Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredContract.map((contract) => (
                    <ContractItem
                      key={contract.contractCode}
                      contract={contract}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {maxPages > 1
              && <Pagination
                sx={{ justifyContent: 'center', mt: 1 }}
                count={maxPages}
                // page={page}
                onChange={(__, value) => setPage(value - 1)}
              />
            }
          </>
        ) :(
          <Typography>No tienes ningún contracto registado</Typography>
        )
      ) : (
        <Box sx={{ textAlign: 'center', mt: 3 }}>
          <CircularProgress size={36} />
        </Box>
      )}
    </Container>
  )
};

export default ClosedContractList;
